export const ReserveNewPreReserveUrl = {
  // Get PreReservation Status
  GetPreReservationStatus: '/PreReserve/PreReserveQuery/GetPreReservationStatus',
  // Get Previous Pilgrims By NationalCode
  GetPreviousPilgrims: '/PreReserve/PreReserveQuery/GetPreviousPilgrimsByNationalCode',
  // Create PreReserve
  CreatePreReserve: '/PreReserve/PreReserveCommand/CreatePreReserve',
}
